import {
  faArrowPointer,
  faArrowUp,
  faArrowUp19,
  faCaretDown,
  faCaretSquareDown,
  faCaretUp,
  faCartArrowDown,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";

const StatCard = ({ icon, title, number, percentage }) => {
  const userType = useSelector((state) => state.user?.user?.roleDetails?.id);
  return (
    <div
      className={`default-border single-stat-card p-5 flex flex-row flex-wrap items-start gap-y-[20px] ${
        [1, 4].includes(userType) ? "" : "min-w-[24%]"
      } bg-white`}
    >
      <img src={icon} alt="Icon" className="p-2 bg-[#EEF3FF] rounded-md" />
      <h3 className="text-[#676767] font-normal w-full">{title}</h3>
      <div className="bottom flex flex-row justify-between w-full">
        <span className="text-[#1C1C1C] font-semibold text-[30px]">
          {number}
        </span>
        <span className="ml-[auto] flex flex-row justify-items-start items-center gap-x-[5px]">
          <img
            src="/assets/images/percentage-icon.svg"
            alt=""
            className={
              percentage < 0 ? "transform rotate-180 down-stats-icon" : ""
            }
          />
          <p
            className={
              percentage < 0
                ? "text-red-700 text-[22px]"
                : "text-[#14CC26] text-[22px]"
            }
          >
            {/* <span className="mr-2">
              <FontAwesomeIcon
                icon={percentage > 0 ? faCaretUp : faCaretDown}
              />
            </span> */}
            {Math.abs(percentage)}%
          </p>
        </span>
      </div>
    </div>
  );
};

export default StatCard;
